var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./LDIndividualSummaryTab.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-21b5f1bc!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./LDIndividualSummaryTab.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/liveDiscussion/tabs/LDIndividualSummaryTab.vue
// module id = 414
// module chunks = 61